import Immutable from 'seamless-immutable';
// ---- external imports ----

import { levelSelectors, turnSelectors } from '~/store';
// ---- internal imports ----


function handleNewCustomMission(state, mission) {
	switch (mission.customHandler) {
	default:
		break;
	};

	return mission;
}

function setupLevel(state, level) {
	const currentLevel = levelSelectors.getLevelData(state, level - 1);
	const missionsTemplate = Immutable.asMutable(currentLevel.missions, { deep: true });
	const curTurnNum = turnSelectors.getTurnNum(state);

	if (missionsTemplate === null) {
		throw new Error(`setupLevel failed, missions in level ${level} is null.`);
	}

	const missions = missionsTemplate.map((mission) => {
		const { customHandler, initial, durationInTurns } = mission;

		if (customHandler) {
			mission = handleNewCustomMission(state, mission);
		}

		if (initial || initial === 0) {
			mission.value = mission.initial;
		}

		if (durationInTurns) {
			mission.checkAtStartOfTurn = curTurnNum + durationInTurns
		}

		mission.completed = false;
		mission.startedInTurn = curTurnNum;

		return mission;
	});

	return missions;
}


export default setupLevel;
